import React from "react";

const TripEmptyState = ({ message }: { message: string }) => {
  return <p className="trip-empty-state">{message}</p>;
};

export default TripEmptyState;
